import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from '../../../common/widgets/ScrollToTop';
import { WithTabTitle } from '../../../common/widgets/withTabTitle';
import { NotFoundPage } from '../Pages/404Page';
import { AnalyticsPage } from '../Pages/Analytics';
import DemoPage from '../Pages/Demo';
import GdprPage from '../Pages/GdprPage';
import { HomePage } from '../Pages/Home';
import { InformationPage } from '../Pages/InformationPage';
import { MarketingPage } from '../Pages/Marketing';
import MerchantsLayout from '../layout/layouts/MerchantsLayout';
import { resources } from '../resources/resources';
import { AccountsRoutes } from './Accounts';
import { NotificationsRoutes } from './Notifications';
import { ProductsRoutes } from './Products';

export function Routing() {
  const { t: translate } = useTranslation();
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path=""
          element={
            <MerchantsLayout>
              <WithTabTitle title={translate(resources.merchantsApp)}>
                <HomePage />
              </WithTabTitle>
            </MerchantsLayout>
          }
        />
        <Route path="products/*" element={<ProductsRoutes />} />
        <Route path="accounts/*" element={<AccountsRoutes />} />
        <Route path="demo" element={<DemoPage />} />
        <Route
          path="analytics"
          element={
            <MerchantsLayout>
              <WithTabTitle title={translate(resources.analytics.title)}>
                <AnalyticsPage />
              </WithTabTitle>
            </MerchantsLayout>
          }
        />
        <Route path="notifications/*" element={<NotificationsRoutes />} />
        <Route
          path="information/:informationId"
          element={
            <MerchantsLayout>
              <InformationPage />
            </MerchantsLayout>
          }
        />
        <Route
          path="gdpr"
          element={
            <MerchantsLayout>
              <GdprPage />
            </MerchantsLayout>
          }
        />
        <Route
          path="marketing"
          element={
            <MerchantsLayout>
              <MarketingPage />
            </MerchantsLayout>
          }
        />
        <Route
          path="*"
          element={
            <MerchantsLayout>
              <NotFoundPage />
            </MerchantsLayout>
          }
        />
      </Routes>
    </>
  );
}
